import {
  NavigateOptions,
  To,
  useLocation,
  useNavigate as useNavigateBase,
  useOutletContext,
} from "react-router-dom";
import { FilterTag, FrontendFilterTag } from "types/types";

export function useNavigate() {
  const location = useLocation();
  const navigateBase = useNavigateBase();
  function navigate(to: To, options?: NavigateOptions) {
    const newLocation =
      typeof to === "string"
        ? { ...location, pathname: to }
        : { ...location, ...to };
    return navigateBase(newLocation, options);
  }

  return navigate;
}

interface TagContext {
  tags: {
    originalTags: FilterTag[];
    treeTags: FrontendFilterTag[];
  };
}

export function useTagsContext() {
  return useOutletContext<TagContext>();
}
